import * as React from "react";

import { AreaType } from "../../../../types/index";
import ToggleButtonGroup from "../../../ToggleButtonGroup";

interface Props {
  areaTypeFilterState: AreaType | null;
  onChange: (filter: AreaType | null) => void;
  disabled?: boolean;
}

class AreaTypeOptions extends React.Component<Props> {
  private isAreaOptionSelected = (filter: AreaType | null): boolean =>
    this.props.areaTypeFilterState === filter;

  private buttonsAreaType = [
    {
      label: "Alle",
      selected: () => this.isAreaOptionSelected(null),
      onClick: () => this.props.onChange(null),
    },
    {
      label: "in area",
      selected: () => this.isAreaOptionSelected(AreaType.IA),
      onClick: () => this.props.onChange(AreaType.IA),
    },
    {
      label: "out of area",
      selected: () => this.isAreaOptionSelected(AreaType.OOA),
      onClick: () => this.props.onChange(AreaType.OOA),
    },
  ];

  public render() {
    return (
      <ToggleButtonGroup
        disabled={this.props.disabled}
        title="Kundengebiet"
        buttons={this.buttonsAreaType}
      />
    );
  }
}

export default AreaTypeOptions;



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/FilterOptions/AreaTypeOptions.tsx